import {BaseRemoteConfiguration, REMOTE_CONFIG} from "../../../../infrastructure/models/base-remote-configuration";

export const FOOTER_MODULE_REMOTE_CONFIG = {
  FOOTER_ISRAEL_JOBS: {
    key: 'FOOTER_ISRAEL_JOBS',
    default: 'https://www.comeet.com/jobs/365scores/B3.006',
    type: REMOTE_CONFIG.KEY_TYPES.string
  },

  FOOTER_DYNAMIC_LINKS: {
    key: 'FOOTER_DYNAMIC_LINKS',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  FOOTER_DYNAMIC_LINKS_TEST: { //TODO: remove after tests
    key: 'FOOTER_DYNAMIC_LINKS_TEST',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  }
}

export class FooterModuleRemoteConfig extends BaseRemoteConfiguration {
  get defaultConfig() {
    return Object.values(FOOTER_MODULE_REMOTE_CONFIG);
  }
}
